import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Caption } from '@xo-union/tk-ui-typography';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import RsvpDropdown from '~/glm/components/guest-list/header/rsvp-filter-dropdown';
import MealDropdown from '~/glm/components/guest-list/cells/meal-dropdown';
import MissingInfoDropdown from '~/glm/components/guest-list/cells/missing-info-dropdown';
import styles from './rsvp-meals-combined-dropdown.scss';

@inject('gdsUiState')
@observer
class FilterGuestsDropDown extends React.Component {
  static propTypes = {
    rsvpFilter: PropTypes.func,
    mealFilter: PropTypes.func,
    event: PropTypes.instanceOf(GdsEventModel),
    gdsUiState: PropTypes.instanceOf(GdsUiState),
  };

  setMenuState = bool => {
    if (typeof bool === 'boolean') {
      this.setState({ menuOpen: bool });
    } else {
      this.setState(state => ({
        menuOpen: !state.menuOpen,
      }));
    }
  };

  render() {
    const { rsvpFilter, mealFilter, event, gdsUiState } = this.props;

    return (
      <div className={styles.combinedDropdown}>
        <Caption className={styles.sectionHeader}>The {event.name}</Caption>
        <RsvpDropdown
          rsvpFilter={rsvpFilter}
          setSelectedFilterData={this.setSelectedFilterData}
          currentSelection={gdsUiState.rsvpFilter}
          setMenuState={this.setMenuState}
          event={event}
          border={false}
        />
        <Caption className={styles.sectionHeader}>Meal Choice</Caption>
        <MealDropdown
          showCheckmark
          onClick={mealFilter}
          mealFilter={gdsUiState.mealFilter}
          meals={event.mealQuestion.options}
          border={false}
        />
        <Caption className={styles.sectionHeader}>Missing Info</Caption>
        <MissingInfoDropdown
          showCheckmark
          addressFilter={gdsUiState.addressFilter}
          gdsUiState={gdsUiState}
          border={false}
        />
      </div>
    );
  }
}

export default FilterGuestsDropDown;
